<template>
    <div id="game_over" v-touch:swipe="swipeHandler">
        <info-default
            imageUrl="gratidao.gif"
            :smallTitle="$t('views.gameOver.smallTitle')"
            :title="$t('views.gameOver.title')"
            :descInfo="redirect.text"
            actionName="goDashboard"
            :textButton="redirect.textButton"
            :backgroundWhite="false"
            :noStyle="false">

        </info-default>
        <report-pagination
            :activeBefore="pagination.activeBefore"
            :activeNext="pagination.activeNext"
            :nextRoutePagination="pagination.nextRoutePagination"
            :beforeRoutePagination="pagination.beforeRoutePagination">
        </report-pagination>
    </div>
</template>

<script>
import ReportPagination from '../components/shared/report/ReportPagination'
import InfoDefault from '../components/shared/default/InfoDefault.vue'
import { Bus } from '../event-bus.js'
export default {
    name: 'GameOver',
    components:{
        'report-pagination': ReportPagination,
        InfoDefault
    },

    data: () => ({
        // score: this.$store.getters.getGameData('currentScore'),
        pagination:{
            activeBefore: true,
            activeNext: false,
            beforeRoutePagination: '/report/competences',
            nextRoutePagination: false
        },
        redirect : {}
    }),
    created(){
        this.redirect = {
            path : '/feedback',
            text : this.$t("views.gameOver.redirectText[0]"),
            textButton : 'Feedback'
        }
        Bus.$on('goDashboard', this.goDashboard)
        localStorage.setItem('secondsDiff', '')
        let feedback = JSON.parse(localStorage.getItem('feedback'))
        if(feedback){
            this.redirect = {
                path : '/dashboard',
                text : this.$t("views.gameOver.redirectText[1]"),
                textButton : 'Dashboard'
            }
        }
        
    },
    destroyed(){
        Bus.$off('goDashboard')
    },
    methods:{
        finish(){
            this.$router.push('/logout')
        },
        swipeHandler (direction) {
            if(direction == 'right') this.$router.push(this.pagination.beforeRoutePagination) 
        },
        goDashboard(){
            this.$router.push(this.redirect.path)
        }      
    }
}

</script>

<style lang="scss" scoped>
    #game_over{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgba($color: #02F0E4, $alpha: .15);
        position: relative;

        .game_over_icon{
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fff;
            width: 270px;
            height: 270px;
            border-radius: 300px;

            img{
                max-width: 75%;
            }
        }

        .game_over_info{
            text-align: center;
            text-transform: uppercase;

            h1{
                color: #333;
                letter-spacing: 5px;
                font-weight: 600;
                font-size: 28px;
                margin: 5%;
            }

            p{
                color: #616E77;
                font-weight: 100;
                letter-spacing: 3px;
                font-size: 11px;
                margin: 0 32px;
                text-transform: none;
                line-height: 18px;
            }
        }

        .game_over_button{

            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10%;

            .button{
                background-color: #FFF581;
                width: 50%;
                padding: 20px;
                text-transform: uppercase;
                text-align: center;
                font-weight: 900;
                letter-spacing: 3px;
                border-bottom: 6px solid rgba($color: #DBD171, $alpha: 1.0);
                -webkit-box-shadow: 0px 5px 0px 0px rgba(0,0,0,0.1);
                -moz-box-shadow: 0px 5px 0px 0px rgba(0,0,0,0.1);
                box-shadow: 0px 5px 0px 0px rgba(0,0,0,0.1);
                transition: border-bottom .2s;

                &:active{
                    border-bottom: none;
                }
            }
        }
        .arrows{
            margin: 0;
        }

    }
</style>
